import { initializeKeyValue } from "lib/initialize-key-value";

export type Head = ReturnType<typeof sanitizeHeads>["head"];
export type Subhead = ReturnType<typeof sanitizeHeads>["subhead"];

export const sanitizeHeads = (option: Record<string, boolean>) => {
  const { Head: head, Subhead: subhead } = initializeKeyValue(option, {
    Head: {
      "#": true,
      Artist: true,
      Track: true,
      Memo: true,
      ArtistTitle: true,
      ArtistUrl: true,
      ArtistGenre: true,
      History: true,
      Role: true
    },
    Subhead: {
      "#": {
        "#": true
      },
      Artist: {
        artistId: true,
        name: true,
        email: true,
        typeArtistClass: true,
        validCheck: true
      },
      Track: {
        count: true
      },
      Memo: {
        memo: true
      },
      ArtistTitle: {
        description: true
      },
      ArtistUrl: {
        thumbnail: true,
        typeUrl: true,
        url: true
      },
      ArtistGenre: {
        name: true,
        type: true
      },
      History: {
        birthDate: true,
        birthPlace: true,
        deathDate: true,
        deathPlace: true
      },
      Role: {
        id: true,
        role: true,
        type: true,
        count: true
      }
    }
  });
  return { head, subhead };
};
